// extracted by mini-css-extract-plugin
export default {"details":"CeccEf","actions":"HmQ8Z7","leftActions":"xQEjrK","mobile":"maD_R8","actionButton":"VvWw29","location":"oamvV0"};